import { Extension } from "../../core/extension";
import { SlashCommandGroup, } from "../../core/types";
import { excalidrawNodesSpec } from "./nodes";
import { createExcalidrawNode } from "./commands";
import { ReactNodeView } from "../../react";
import { ExcalidrawNodeView } from "./components/ExcalidrawNodeView/ExcalidrawNodeView";
export class ExcalidrawExtension extends Extension {
    constructor(service, filestackService) {
        super();
        this.service = service;
        this.filestackService = filestackService;
    }
    addNodes(nodes) {
        return nodes.append(excalidrawNodesSpec());
    }
    addPlugins(schema, plugins, _context) {
        return plugins.concat([]);
    }
    addNodeViews(schema, nodeViews, portalContainer) {
        return {
            ...nodeViews,
            excalidraw: ReactNodeView.create({
                portalContainer,
                component: ExcalidrawNodeView,
                extraProps: {
                    service: this.service,
                    filestackService: this.filestackService,
                },
            }),
        };
    }
    addSlashCommands(commands) {
        return [
            ...commands,
            this.service.isEditable()
                ? {
                    label: "Whiteboard (deprecated)",
                    description: "Insert a whiteboard diagram",
                    group: SlashCommandGroup.Advanced,
                    icon: "reports",
                    iconSize: "L",
                    iconColor: "#00cbc5",
                    command: (match, view) => {
                        view.dispatch(view.state.tr.deleteRange(match.range.from, match.range.to));
                        const node = createExcalidrawNode(view, "[]", 500, 500);
                        view.dispatch(view.state.tr.replaceSelectionWith(node));
                    },
                }
                : undefined,
        ].filter(Boolean);
    }
}
